import { z } from "zod";

import { VIEWER_LOCALES } from "./viewerPreferences";

export const localeSchema = z.enum(VIEWER_LOCALES);
